import { render, staticRenderFns } from "./Luckdraw.vue?vue&type=template&id=00085603&scoped=true"
import script from "./Luckdraw.vue?vue&type=script&lang=js"
export * from "./Luckdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00085603",
  null
  
)

export default component.exports